var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25992 9.28016C5.06992 9.28016 4.87992 9.21016 4.72992 9.06016L1.19992 5.53016C0.909922 5.24016 0.909922 4.76016 1.19992 4.47016L4.72992 0.940156C5.01992 0.650156 5.49992 0.650156 5.78992 0.940156C6.07992 1.23016 6.07992 1.71016 5.78992 2.00016L2.78992 5.00016L5.78992 8.00016C6.07992 8.29016 6.07992 8.77016 5.78992 9.06016C5.64992 9.21016 5.45992 9.28016 5.25992 9.28016Z",
    fill: "#40196D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.08abfa028d77b6a5969fa1c3f499786d.svg";
export { ForwardRef as ReactComponent };